<template>
  <div id="sticky-notes">
    <!-- Modal de Apagar Lembrete -->
    <div id="modal-delete" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir Lembrete</h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <h6 class="font-weight-semibold">
              Tem certeza que deseja excluir o lembrete?
            </h6>
            <p>{{ selectedStickyNote.PS_LEMBRETE_TEXTO }}</p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-link text-danger"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteStikyNote"
            >
              Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal de Apagar Lembrete -->
    <!-- Modal de Editar Lembrete -->
    <div id="modal-edit" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="updateStikyNote">
            <div class="modal-header">
              <h5 class="modal-title">Atualizar Lembrete</h5>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <p>
                <span class="text-danger">Atenção:</span> O ano e o mês se
                refere ao período em que você quer ser lembrado.
              </p>
              <p>
                Dados de clientes que são necessários (Nome, CODCFO, N° da
                Coligada, E-mail e Telefone)
              </p>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Ano: <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      required
                      v-model="selectedStickyNote.PS_LEMBRETE_ANO"
                    >
                      <option value="" selected="" disabled="">
                        Selecione um ano
                      </option>
                      <option value="2020" title="2020">2020</option>
                      <option value="2021" title="2021">2021</option>
                      <option value="2022" title="2022">2022</option>
                      <option value="2023" title="2023">2023</option>
                      <option value="2024" title="2024">2024</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Mês: <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="selectedStickyNote.PS_LEMBRETE_MES"
                    >
                      <option value="" selected="" disabled="">
                        Selecione um mês
                      </option>
                      <option value="1" title="01">01</option>
                      <option value="2" title="02">02</option>
                      <option value="3" title="03">03</option>
                      <option value="4" title="04">04</option>
                      <option value="5" title="05">05</option>
                      <option value="6" title="06">06</option>
                      <option value="7" title="07">07</option>
                      <option value="8" title="08">08</option>
                      <option value="9" title="09">09</option>
                      <option value="10" title="10">10</option>
                      <option value="11" title="11">11</option>
                      <option value="12" title="12">12</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div>Lembrar: <span class="text-danger">*</span></div>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        mt-2
                      "
                    >
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="PS_LEMBRETE_TIPO"
                        id="PS_LEMBRETE_TIPO_UMA_VEZ"
                        value="Uma Vez"
                        v-model="selectedStickyNote.PS_LEMBRETE_TIPO"
                      />
                      <label
                        class="custom-control-label"
                        for="PS_LEMBRETE_TIPO_UMA_VEZ"
                      >
                        Uma Vez</label
                      >
                    </div>

                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        mt-2
                      "
                    >
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="PS_LEMBRETE_TIPO"
                        id="PS_LEMBRETE_TIPO_SEMPRE"
                        value="Sempre"
                        v-model="selectedStickyNote.PS_LEMBRETE_TIPO"
                      />
                      <label
                        class="custom-control-label"
                        for="PS_LEMBRETE_TIPO_SEMPRE"
                        >Sempre</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Lembrete: <span class="text-danger">*</span></label>
                    <textarea
                      class="form-control resize-none"
                      id="PS_LEMBRETE_TEXTO"
                      name="PS_LEMBRETE_TEXTO"
                      placeholder="Descreva o que você quer lembrar"
                      maxlength="2000"
                      rows="8"
                      v-model="selectedStickyNote.PS_LEMBRETE_TEXTO"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link text-warning"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="updateStikyNote"
              >
                Atualizar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Modal de Editar Lembrete -->
    <!-- Modal de Adicionar Lembrete -->
    <div id="modal-add-sticky-note" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="insertStickyNote">
            <div class="modal-header">
              <h5 class="modal-title">Cadastrar Lembrete</h5>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <p>
                <span class="text-danger">Atenção:</span> O ano e o mês se
                refere ao período em que você quer ser lembrado.
              </p>
              <p>
                Dados de clientes que são necessários (Nome, CODCFO, N° da
                Coligada, E-mail e Telefone)
              </p>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Ano: <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      required
                      v-model="newStickyNote.PS_LEMBRETE_ANO"
                    >
                      <option value="" selected="" disabled="">
                        Selecione um ano
                      </option>
                      <option value="2020" title="2020">2020</option>
                      <option value="2021" title="2021">2021</option>
                      <option value="2022" title="2022">2022</option>
                      <option value="2023" title="2023">2023</option>
                      <option value="2024" title="2024">2024</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Mês: <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="newStickyNote.PS_LEMBRETE_MES"
                    >
                      <option value="" selected="" disabled="">
                        Selecione um mês
                      </option>
                      <option value="1" title="01">01</option>
                      <option value="2" title="02">02</option>
                      <option value="3" title="03">03</option>
                      <option value="4" title="04">04</option>
                      <option value="5" title="05">05</option>
                      <option value="6" title="06">06</option>
                      <option value="7" title="07">07</option>
                      <option value="8" title="08">08</option>
                      <option value="9" title="09">09</option>
                      <option value="10" title="10">10</option>
                      <option value="11" title="11">11</option>
                      <option value="12" title="12">12</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div>Lembrar: <span class="text-danger">*</span></div>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        mt-2
                      "
                    >
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="PS_LEMBRETE_TIPO"
                        id="PS_LEMBRETE_TIPO_UMA_VEZ"
                        value="Uma Vez"
                        v-model="newStickyNote.PS_LEMBRETE_TIPO"
                        @click="newStickyNote.PS_LEMBRETE_TEXTO = 'Uma Vez'"
                      />
                      <label
                        class="custom-control-label"
                        for="PS_LEMBRETE_TIPO_UMA_VEZ"
                      >
                        Uma Vez</label
                      >
                    </div>

                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        mt-2
                      "
                    >
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="PS_LEMBRETE_TIPO"
                        id="PS_LEMBRETE_TIPO_SEMPRE"
                        value="Sempre"
                        @click="newStickyNote.PS_LEMBRETE_TEXTO = 'Sempre'"
                        v-model="newStickyNote.PS_LEMBRETE_TIPO"
                      />
                      <label
                        class="custom-control-label"
                        for="PS_LEMBRETE_TIPO_SEMPRE"
                        >Sempre</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Lembrete: <span class="text-danger">*</span></label>
                    <textarea
                      class="form-control resize-none"
                      id="PS_LEMBRETE_TEXTO"
                      name="PS_LEMBRETE_TEXTO"
                      placeholder="Descreva o que você quer lembrar"
                      maxlength="2000"
                      rows="8"
                      v-model="newStickyNote.PS_LEMBRETE_TEXTO"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link text-success"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="submit" class="btn btn-success">Cadastrar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Modal de Editar Lembrete -->
    <div class="d-flex">
      <div class="header-title">
        <h3 class="font-weight-light">Lembretes</h3>
      </div>
      <div class="ml-auto">
        <button
          type="button"
          class="btn btn-success"
          data-toggle="modal"
          data-target="#modal-add-sticky-note"
        >
          <i class="fas fa-plus"></i>
          Adicionar Lembrete
        </button>
      </div>
    </div>
    <loading-data v-if="isLoading"></loading-data>
    <div
      v-else
      class="card bg-secondary-100"
      v-for="stickNote in stickyNotes"
      :key="stickNote.PS_LEMBRETE_ID"
    >
      <div class="card-body">
        <div class="d-flex align-content-center align-items-center">
          <div class="status-icon mr-2 text-center">
            <div v-html="typeStickTranslate(stickNote.PS_LEMBRETE_TIPO)"></div>
            <p class="">{{ stickNote.PS_LEMBRETE_TIPO }}</p>
            <div class="d-flex text-center">
              <span
                class="badge bg-yellow cursor-pointer mr-1"
                @click="openModalEditStickyNote(stickNote)"
                >Editar</span
              >
              <span
                class="badge bg-danger cursor-pointer mr-1"
                @click="openModalConfirmDeleteStickyNote(stickNote)"
              >
                Excluir
              </span>
            </div>
          </div>
          <div class="sticky-text text-justify">
            {{ stickNote.PS_LEMBRETE_TEXTO }}
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between py-1">
        <span class=""
          >Cadastrado por: {{ stickNote.CRIACAO_USUARIO }} em
          {{ dateTimeSqlToDateTimeBR(stickNote.CRIACAO_DATA) }}</span
        >
        <span v-if="stickNote.MODIFICACAO_USUARIO" class=""
          >Modificado por: {{ stickNote.MODIFICACAO_USUARIO }} em
          {{ dateTimeSqlToDateTimeBR(stickNote.MODIFICACAO_DATA) }}</span
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
.status-icon {
  width: 110px !important;
}
.sticky-text {
  max-width: calc(100% - 110px);
}
</style>
<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import { typeStickTranslate } from '@/utils/statusesTranslator'

export default {
  name: 'StickyNotes',

  components: {
    LoadingData,
  },

  props: {
    unityId: {
      type: Number,
      required: true,
    },
    periodId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      stickyNotes: [],
      dateTimeSqlToDateTimeBR,
      typeStickTranslate,
      selectedStickyNote: {
        PS_LEMBRETE_ID: '',
        PS_LEMBRETE_TEXTO: '',
        PS_LEMBRETE_TIPO: '',
        PS_LEMBRETE_ANO: '',
        PS_LEMBRETE_MES: '',
        PS_LEMBRETE_UNIDADE_ID: this.unityId,
      },
      newStickyNote: {
        PS_LEMBRETE_TEXTO: '',
        PS_LEMBRETE_TIPO: '',
        PS_LEMBRETE_ANO: '',
        PS_LEMBRETE_MES: '',
        PS_LEMBRETE_UNIDADE_ID: this.unityId,
      },
    }
  },

  computed: {},

  methods: {
    openModalConfirmDeleteStickyNote(stickNote) {
      this.selectedStickyNote = stickNote
      window.$('#modal-delete').modal()
    },
    openModalEditStickyNote(stickNote) {
      this.selectedStickyNote = stickNote
      window.$('#modal-edit').modal()
    },
    async updateStikyNote() {
      try {
        if (this.selectedStickyNote.PS_LEMBRETE_ID) {
          const operation = await this.$store.dispatch('updateStikyNote', {
            stickyId: this.selectedStickyNote.PS_LEMBRETE_ID,
            periodId: this.periodId,
            unityId: this.unityId,
            sticky: this.selectedStickyNote,
          })
          if (operation.status) {
            this.$root.$children[0].$refs.notification.success(
              operation.message,
            )
            window.$('#modal-edit').modal('hide')
            this.getStickyNotes()
          }
        } else {
          this.$root.$children[0].$refs.notification.warning(
            'Lembrete não encontrado',
          )
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async insertStickyNote() {
      try {
        const operation = await this.$store.dispatch('insertStickyNote', {
          periodId: this.periodId,
          unityId: this.unityId,
          sticky: this.newStickyNote,
        })
        if (operation.status) {
          this.$root.$children[0].$refs.notification.success(operation.message)
          window.$('#modal-add-sticky-note').modal('hide')
          this.getStickyNotes()
        } else {
          this.$root.$children[0].$refs.notification.warning(operation.message)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async deleteStikyNote() {
      try {
        if (this.selectedStickyNote.PS_LEMBRETE_ID) {
          const operation = await this.$store.dispatch('deleteStickyNote', {
            stickyId: this.selectedStickyNote.PS_LEMBRETE_ID,
            periodId: this.periodId,
            unityId: this.unityId,
          })
          if (operation.status) {
            this.$root.$children[0].$refs.notification.success(
              operation.message,
            )
            window.$('#modal-delete').modal('hide')
            this.getStickyNotes()
          }
        } else {
          this.$root.$children[0].$refs.notification.warning(
            'Lembrete não encontrado',
          )
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async getStickyNotes() {
      try {
        this.isLoading = true
        this.stickyNotes = await this.$store.dispatch('getStickyNotes', {
          unityId: this.unityId,
          periodId: this.periodId,
        })
        this.$emit('stickyNotes', this.stickyNotes)
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  watch: {
    unityId: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.getStickyNotes()
          this.newStickyNote.PS_LEMBRETE_UNIDADE_ID = newVal
        }
      },
    },
  },

  mounted() {
    if (this.unityId && this.periodId) {
      this.getStickyNotes()
    }
  },
}
</script>
